export class AuthorizationError extends Error {
}

export class NotFound extends Error {
  constructor(message?: string) {
    super(message);
  }
}

export class ModalClosed extends Error {
  constructor(message = 'modal closed') {
    super(message);
  }
}

export function isExpectedError(value: any): value is Error {
  return value instanceof ModalClosed || value instanceof NotFound;
}
